// import SliderArrow from "~/assets/images/icons/slider-arrow.svg?inline";

export default {
  name: "photos",

  data() {
    return {
      gkey: process.env.VUE_APP_GOOGLE_MAPS_KEY,
      size: "720x220",
      windowWidth: 0
    };
  },

  props: {
    photos: {
      type: Array,
      default: []
    },
    coordinates: {
      type: Object,
      default: []
    },
    street: {
      type: String,
      default: "AnyCurb"
    },
    isOnMarket: {
      type: Boolean,
      default: false
    }
  },

  created() {
    window.addEventListener("resize", this.handleResize);

    let height = (440 * 1440) / window.innerWidth;

    this.size = `2048x${Math.round(height)}`;
  },

  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },

  methods: {
    showGallary() {
      this.$emit("handleShowGallary", true);
    },

    handler: function(e) {
      e.preventDefault();
    }
  }
};
